import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CookieConsentService {
    init(): void {
        // tslint:disable
        const cookieConsent = window['__env'].cookieConsent;
        if (!cookieConsent) {
            return;
        }
        const { src, domainScript } = cookieConsent;

        const openComment = document.createComment('OneTrust Cookies Consent Notice start for gatepass.deloitte.com');
        const closeComment = document.createComment('OneTrust Cookies Consent Notice end for gatepass.deloitte.com');

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.charset = 'UTF-8';
        script.src = src;
        script.dataset.domainScript = domainScript;

        // Define OptanonWrapper without creating an inline script,
        // so it complies with strict CSP (no unsafe-inline).
        (window as any).OptanonWrapper = () => { };

        document.head.appendChild(openComment);
        document.head.appendChild(script);
        document.head.appendChild(closeComment);
    }
}
